import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Buildpurpose(props) {
  return (
    <div className="services_orange_bg p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center order-2 order-md-1"
          >
            <StaticImage
              src="../../images/services/servless-computing/improve_business.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={776}
              height={651}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="services_title my-auto order-1 order-md-2"
          >
            <h2>
              Improve Your Business Production with Serverless Computing
              Services
            </h2>
            <p>
              We know the hassle of managing the physical hardware or
              infrastructure required to run a server. Our serverless computing
              radically simplifies the software delivery, management, and
              operational processes. TekRevol sees the serverless architecture
              as a whole new perception and believes that the workflow and
              architecture can be further improved to ensure scalability,
              capacity planning, and easy maintenance.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Buildpurpose;
